import { ReactNode } from "react";
import Header from "./component/StaticHeader";
import StaticFooter from "./component/StaticFooter";

export default function StaticLayout({ children }: { children: ReactNode }) {
  return (
    <div>
      <Header />
      <div className=" min-h-screen relative ">{children}</div>
      <StaticFooter />
    </div>
  );
}
